// extracted by mini-css-extract-plugin
export default {"linkcontainer":"CustomEventHeader_linkcontainer__OQCiw","links":"CustomEventHeader_links__aI-Hz","active":"CustomEventHeader_active__CoPlX"};